var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#B3BA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38563 5.9985L7.3125 6.04294L10.6875 11.25V6.03844L9.00225 5.0625L7.38563 5.9985ZM7.3125 11.9053L9.0765 12.9375L10.6875 11.997L7.3125 6.75V11.9053ZM5.625 6.95025V11.0497L6.75 11.8125V6.1875L5.625 6.95025ZM11.25 11.8125L12.375 11.0323V6.96769L11.25 6.1875V11.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25C5.27344 2.25 2.25 5.27344 2.25 9C2.25 12.7266 5.27344 15.75 9 15.75C12.7266 15.75 15.75 12.7266 15.75 9C15.75 5.27344 12.7266 2.25 9 2.25ZM8.97187 13.2863L5.32912 11.1263V6.813L8.97244 4.65862L12.6152 6.813V11.1268L8.97244 13.2857L8.97187 13.2863Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeu);
export default __webpack_public_path__ + "static/media/neu.6e4b78ab9623457db6fe32776326093f.svg";
export { ForwardRef as ReactComponent };